import { useQuery } from "@apollo/client";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { GET_PRICELISTS } from "@/containers/B2BCustomers/B2BCustomersQueries";

interface PriceListSelectProps {
  field: {
    value: number | null;
    onChange: (value: number | null) => void;
  };
  unSelect?: boolean;
}

export default function PriceListSelect({
  field,
  unSelect = true,
}: PriceListSelectProps) {
  const { data, loading } = useQuery(GET_PRICELISTS);

  if (loading) {
    return <div>Loading...</div>;
  }

  // Select default price list when unSelect is false and no value is selected
  if (!unSelect && !field.value && data?.findManyPriceList?.length > 0) {
    const defaultPriceList = data.findManyPriceList.find(
      (priceList: any) => priceList.default === true
    );
    if (defaultPriceList) {
      field.onChange(defaultPriceList.id);
    }
  }

  return (
    <Select
      value={field.value?.toString() || "none"}
      onValueChange={(value) => {
        field.onChange(value === "none" ? null : parseInt(value));
      }}
    >
      <SelectTrigger className="w-full px-2 flex items-center gap-2">
        <div className="flex items-center gap-1">
          <span className="text-sm text-gray-500">Pricelist:</span>
          <SelectValue placeholder="Select price list" />
        </div>
      </SelectTrigger>
      <SelectContent>
        {unSelect && <SelectItem value="none">None</SelectItem>}
        {data?.findManyPriceList.map((priceList: any) => (
          <SelectItem key={priceList.id} value={priceList.id.toString()}>
            {priceList.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
